/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateUpdateVehicleModelReferenceRequest
 */
export interface CreateUpdateVehicleModelReferenceRequest {
    /**
     *
     * @type {string}
     * @memberof CreateUpdateVehicleModelReferenceRequest
     */
    make?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUpdateVehicleModelReferenceRequest
     */
    model?: string;
    /**
     *
     * @type {string}
     * @memberof CreateUpdateVehicleModelReferenceRequest
     */
    vehicleType?: CreateUpdateVehicleModelReferenceRequestVehicleTypeEnum;
    /**
     *
     * @type {number}
     * @memberof CreateUpdateVehicleModelReferenceRequest
     */
    batteryCapacityKwh?: number;
}

/**
 * @export
 */
export const CreateUpdateVehicleModelReferenceRequestVehicleTypeEnum = {
    Unknown: "Unknown",
    Bev: "BEV",
    Phev: "PHEV",
    Fcev: "FCEV",
} as const;
export type CreateUpdateVehicleModelReferenceRequestVehicleTypeEnum =
    (typeof CreateUpdateVehicleModelReferenceRequestVehicleTypeEnum)[keyof typeof CreateUpdateVehicleModelReferenceRequestVehicleTypeEnum];

/**
 * Check if a given object implements the CreateUpdateVehicleModelReferenceRequest interface.
 */
export function instanceOfCreateUpdateVehicleModelReferenceRequest(
    value: object,
): value is CreateUpdateVehicleModelReferenceRequest {
    return true;
}

export function CreateUpdateVehicleModelReferenceRequestFromJSON(
    json: any,
): CreateUpdateVehicleModelReferenceRequest {
    return CreateUpdateVehicleModelReferenceRequestFromJSONTyped(json, false);
}

export function CreateUpdateVehicleModelReferenceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CreateUpdateVehicleModelReferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        make: json["make"] == null ? undefined : json["make"],
        model: json["model"] == null ? undefined : json["model"],
        vehicleType:
            json["vehicleType"] == null ? undefined : json["vehicleType"],
        batteryCapacityKwh:
            json["batteryCapacityKwh"] == null
                ? undefined
                : json["batteryCapacityKwh"],
    };
}

export function CreateUpdateVehicleModelReferenceRequestToJSON(
    value?: CreateUpdateVehicleModelReferenceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        make: value["make"],
        model: value["model"],
        vehicleType: value["vehicleType"],
        batteryCapacityKwh: value["batteryCapacityKwh"],
    };
}
